import { render, staticRenderFns } from "./X4y.vue?vue&type=template&id=2a6c6384"
import script from "./X4y.vue?vue&type=script&lang=js"
export * from "./X4y.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports